import { Button, Flex, Modal, Typography } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomTitle } from "../customTitle";
import Actions from "../../../redux/actions";
import { useTranslation } from "react-i18next";

const VerificationDialog = () => {
  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  const { t } = useTranslation("newAccountVerification");

  /* loading dependencies */
  const [loading, setLoading] = useState(false);

  /* perform delete action */
  const handleClose = () => {
    dispatch(Actions.createAction(Actions.VERIFIED_DIALOG_CLOSE));
  };

  const user = useSelector((state) => state?.auth?.loginDetails);

  const isVerifiedDialogOpen = useSelector(
    (state) => state.common.verifiedDialog
  );

  const isOrgVerified = user?.organization_id?.organization_verified;

  useEffect(() => {
    if (user && isOrgVerified !== undefined && !isOrgVerified) {
      dispatch(Actions.createAction(Actions.VERIFIED_DIALOG_OPEN));
    }
  }, [isOrgVerified]);

  return (
    <Modal
      open={isVerifiedDialogOpen}
      onCancel={handleClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("title")}
        </CustomTitle>
        <Typography level={3}>{t("VerificationMessage")}</Typography>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleClose}>
            {t("Close")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default VerificationDialog;
